import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSeo } from "@/hooks/useSeo";
import FaqJsonLd from "@/components/FaqJsonLd";

const DEFAULT_INTRO = "PROXIreduc-28 est la plateforme d'avantages locaux réservée aux salariés d'entreprises partenaires, aux membres de clubs sportifs et associations, ainsi qu'aux fonctionnaires de l'Eure-et-Loir. Nous négocions des réductions exclusives auprès des commerces locaux, dans 9 pôles couvrant tout le département.";

export default function About() {
  useSeo({
    title: "À propos de PROXIreduc-28 — la plateforme locale de l'Eure-et-Loir",
    description: "Découvrez PROXIreduc-28 : la plateforme numérique de proximité qui connecte habitants, commerçants, artisans, associations et clubs de Chartres, Dreux et de tout l'Eure-et-Loir (28).",
    canonicalPath: "/a-propos",
    image: "/og-image.jpg",
  });
  const [intro, setIntro] = useState(DEFAULT_INTRO);

  useEffect(() => {
    api.get("/public/site-content")
      .then(({ data }) => { if (data?.["about.intro"]) setIntro(data["about.intro"]); })
      .catch(() => {});
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <FaqJsonLd faq={[
        { q: "Qu'est-ce que PROXIreduc-28 ?", a: "PROXIreduc-28 est la plateforme numérique de proximité de l'Eure-et-Loir (28) : elle connecte habitants, commerçants, artisans, professionnels, associations et clubs de Chartres, Dreux et de tout le département." },
        { q: "PROXIreduc-28 est-il gratuit ?", a: "L'inscription et l'usage sont gratuits pour les particuliers. Les professionnels bénéficient d'une offre de lancement avec 12 mois gratuits, sans carte bancaire ni engagement." },
        { q: "Quelle zone géographique couvre PROXIreduc-28 ?", a: "Toute l'Eure-et-Loir (département 28), en priorité Chartres, Dreux, Châteaudun, Nogent-le-Rotrou, Lucé, Mainvilliers et l'ensemble des communes du territoire." },
      ]} />
      <h1 className="font-heading text-4xl font-extrabold">À propos de PROXIreduc-28</h1>
      <p className="mt-4 text-lg text-slate-700" data-testid="about-intro">{intro}</p>
      <div className="mt-8 grid md:grid-cols-3 gap-5">
        {[
          {t: "9 pôles couverts", d: "Chartres, Châteaudun, Dreux, Brou, Épernon, Nogent-le-Rotrou, Bonneval, Courville-sur-Eure et Illiers-Combray (~15 km autour de chaque)."},
          {t: "Réservé aux bénéficiaires", d: "Salariés, adhérents clubs/associations, fonctionnaires — sur activation de compte."},
          {t: "100% local", d: "Chaque commerce est vérifié et chaque offre validée par notre équipe."},
        ].map((c) => (
          <div key={c.t} className="bg-white border border-slate-200 rounded-2xl p-5">
            <div className="font-heading font-bold text-lg">{c.t}</div>
            <p className="mt-2 text-slate-600 text-sm">{c.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
